import React from 'react';
import LazyLoad from 'react-lazyload';

const Timeline = props => (
  <div className="container">
    <div className="row">
      <h2>Vespa modeli kroz vrijeme</h2>
    </div>
    <div className="row">
      {props.timeline.map(({ heading, year, desc, photo }, i) => (
        <LazyLoad offset={10}>
          <div className="col-lg-6 col-md-6 u-mb-30">
            <div className="p-4 py-5 u-h-100p border rounded box-shadow-v2--onHover">
              <h4 className="u-fs-26 u-pt-30 u-pb-20">
                <span className="text-red">{year}</span> {heading}
              </h4>
              {i % 2 ? (
                <div>
                  <p>{desc}</p>
                  <p>
                    <img src={`/images/history/${photo}`} alt={heading} />
                  </p>
                </div>
              ) : (
                <div>
                  <p>
                    <img src={`/images/history/${photo}`} alt={heading} />
                  </p>
                  <p>{desc}</p>
                </div>
              )}
            </div>
          </div>
        </LazyLoad>
      ))}
    </div>
  </div>
);

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/Timeline.js